module.exports = __webpack_public_path__ + "img/operationLog.28718193.svg";